module.exports = __webpack_public_path__ + "static/media/goods2_1.7e55deaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods2_1.png
// module id = 1227
// module chunks = 0